import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Modal, ModalProps, notification, Typography } from 'antd';

import { useBrandsSlice, useJoinBrandsMutation } from 'entities/Brand';
import { useSetRejectedMutation } from 'entities/Notification';
import { JoinForm } from 'shared/ui';

interface IJoinInviteBrandProps extends ModalProps {}

export const JoinInviteBrand: FC<IJoinInviteBrandProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { joinedInviteBrand, setJoinedInviteBrand } = useBrandsSlice();
	const [joinBrand, { status, isLoading }] = useJoinBrandsMutation();
	const [setRejected] = useSetRejectedMutation();

	useEffect(() => {
		if (status === 'fulfilled') {
			setRejected({ ids: [joinedInviteBrand?.notificationId || 0], delete_invite: false });
			setJoinedInviteBrand(null);
			notification.open({
				message: t('Заявка отправлена успешно'),
				description: t('Ваши площадки будут подключены к брэнду'),
				type: 'success',
				placement: 'topRight',
				showProgress: true,
				pauseOnHover: true,
			});
		}
	}, [status]); // eslint-disable-line

	if (!joinedInviteBrand?.brand) return null;

	const { brand, source } = joinedInviteBrand;

	return (
		<Modal
			{...props}
			width={450}
			open={!!joinedInviteBrand}
			onCancel={() => setJoinedInviteBrand(null)}
			centered
			footer={null}>
			<Flex vertical gap={24}>
				<Typography.Title level={4} style={{ margin: 0 }}>
					{t('Заявка на подключение')}
				</Typography.Title>

				<JoinForm
					brand={brand}
					isInvite
					source={source}
					isLoading={isLoading}
					sourceOptions={[{ label: source.name, value: source.uuid }]}
					onJoin={joinBrand}
					onClose={() => setJoinedInviteBrand(null)}
				/>
			</Flex>
		</Modal>
	);
};
